import React from 'react'
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom'
import {
  AUTHENTICATED_ENTRY,
  AUTH_PREFIX_PATH,
  REDIRECT_COMPONENT_KEY,
} from 'configs/AppConfig'
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig'
import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import AppRoute from './AppRoute'
import AppLayoutOutlet from 'layouts/AppLayoutOutlet'
import AuthLayoutOutlet from 'layouts/AuthLayoutOutlet'
import { useSelector } from 'react-redux'
import { ADMIN_TYPE, SUBADMIN_TYPE } from 'constants/AuthConstant'

const canAccessRoute = (route, type, roles) => {
  if (route.isPage) {
    return true
  }
  if (route.key === REDIRECT_COMPONENT_KEY) {
    return true
  }
  if (type === ADMIN_TYPE) {
    return true
  }
  if (type === SUBADMIN_TYPE || type === 'Sub-admin') {
    const role = roles?.[route.key]
    return Boolean(role?.view ?? role?.viewOnly)
  }
  return false
}

const Routes = () => {
  const { type, roles } = useSelector((state) => state.auth)

  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route element={<AppLayoutOutlet />}>
          <Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
          {protectedRoutes.map((route, index) => {
            if (!canAccessRoute(route, type, roles)) {
              return null
            }
            return (
              <Route
                key={`${route.key}-${index}`}
                path={route.path}
                element={
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...(route.meta || {})}
                  />
                }
              />
            )
          })}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
      <Route path="/" element={<PublicRoute />}>
        <Route element={<AuthLayoutOutlet />}>
          {publicRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute routeKey={route.key} component={route.component} />
              }
            />
          ))}
          <Route
            path={AUTH_PREFIX_PATH}
            element={<Navigate to={`${AUTH_PREFIX_PATH}/login`} replace />}
          />
        </Route>
      </Route>
    </RouterRoutes>
  )
}

export default Routes
